import { useEffect, useMemo, useState } from "react";
import FeedbackRating from "./feedbackRating";
import ReactModal from "react-modal";
import { IFeedback, ISendMail } from "../../models/common/IUserProfile";
import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch } from "react-redux";
import {
  createFeedback,
  getDescriptionText,
  getPortalRating,
  getToMailId,
} from "../../action/common/commonActionCreator";
import { Rating } from "react-simple-star-rating";
import { getAlertData } from "../../helper/sweet-alert";
import { emailBlockId, pageBlockId } from "../../constants/pageBlocks";
import { setToMailId } from "../../store/slices/common/commonSlice";
import { UserRole } from "../../constants/RoleEnum";
import { baseURL } from "../../constants/commonConstants";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../constants/routerUrl";
import { getSnapShots } from "../../action/masters/snapShotActionCreator";
import {
  getPageBlockData,
  mailValidation,
} from "../../common-functions/commonFunctions";
import { UserTypes } from "../../models/dashboard/adminDashboard";

const Feedback = (props: IFeedback) => {
  const {
    getPortalRating,
    portalRating,
    SendFeedback,
    getToMailId,
    toMailId,
    currentUser,
    description,
    role,
    getDescriptionText,
    getSnapShot,
    snapShots,
  } = props;
  const navigate = useNavigate();
  const [showRating, setShowRating] = useState(false);
  const [subject, setSubject] = useState<string>("");
  const [content, setContent] = useState<string>("");
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [showAlertCancel, setShowAlertCancel] = useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [isSending, setIsSending] = useState<boolean>(false);
  const adminFeedbackEmail = process.env.REACT_APP_ADMIN_FEEDBACK;
  const dispatch = useDispatch();

  useEffect(() => {
    if (role && role !== UserRole.SuperAdmin)
      getToMailId(emailBlockId.Feedback);
    getSnapShot();
    if (role) {
      if (role === UserRole.Student) {
        getDescriptionText(pageBlockId?.feedback);
      } else if (role === UserRole.Staff) {
        getDescriptionText(pageBlockId?.staffFeedback);
      } else if (role === UserRole.Faculty) {
        getDescriptionText(pageBlockId?.facultyFeedback);
      }
    }
    if (!portalRating) {
      getPortalRating();
    }
    return () => {
      dispatch(setToMailId(""));
    };
  }, [getPortalRating, portalRating, role]);

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const handleSendMail = () => {
    let alertData = mailValidation(subject, content,[toMailId ? toMailId : adminFeedbackEmail ?? ""] );
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
      return;
    }

    if (isSending) return;

    setIsSending(true);

    const toEmail =
      currentUser.currentRole === UserRole.SuperAdmin
        ? [adminFeedbackEmail]
        : [toMailId];

    const mailData: ISendMail = {
      toEmail: toEmail.filter((email): email is string => email !== undefined),
      subject: subject,
      content: `${content}<br><br>Regards,<br>${currentUser.displayName}<br>${
        currentUser.currentRole && UserRole[currentUser.currentRole]
      }`,
    };

    if (mailData?.toEmail && mailData.toEmail?.length > 0) {
      SendFeedback(mailData, (type: string) => {
        setAlert(type);
        setIsSending(false);
        if (type === "emailSuccess") {
          setSubject("");
          setContent("");
        }
      });
    } else {
      setIsSending(false);
    }
  };

  const handleOpenModal = () => setShowRating(true);
  const handleCloseModal = () => setShowRating(false);

  const onConfirm = () => {
    setShowAlert(false);
  };

  const onCancel = () => {
    setSubject("");
    setContent("");
    switch (role) {
      case UserRole.SuperAdmin:
        navigate(ROUTER_URL.COLLEGE_INDEX);
        break;
      case UserRole.CollegeAdmin:
        navigate(ROUTER_URL.COLLEGE_DETAILS);
        break;
      case UserRole.DepartmentAdmin:
        navigate(ROUTER_URL.DEPARTMENT_DETAILS);
        break;
      case UserRole.Staff:
        navigate(ROUTER_URL.STAFF_DASHBOARD);
        break;
      case UserRole.Faculty:
        navigate(ROUTER_URL.FACULTY_DASHBOARD);
        break;
      case UserRole.Student:
        navigate(ROUTER_URL.STUDENT_DASHBOAD);
        break;
      default:
        break;
    }
  };

  const getUserPageBlockData = useMemo(() => {
    switch (currentUser?.currentRole as unknown as UserTypes) {
      case UserTypes.Student:
        return pageBlockId.feedback;
      case UserTypes.Staff:
        return pageBlockId.staffFeedback;
      case UserTypes.Faculty:
        return pageBlockId.facultyFeedback;
      default:
        return 0;
    }
  }, [currentUser?.currentRole, snapShots, pageBlockId]);

  const userPageBlockData = getUserPageBlockData ?? null;
  const pageBlockData = getPageBlockData(snapShots, userPageBlockData);

  useEffect(() => {
    console.log(snapShots);
  }, [snapShots]);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot
            ? "card-wrap h-auto feedback-mobile"
            : "card-wrap h-auto feedback-mobile card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="feedbackwrap">
          <div className="title">
            <div className="w-50">
              <h2 className="mb-2">Feedback</h2>
              {pageBlockData?.displayOrNot && description?.description && (
                <p>{description.description}</p>
              )}
            </div>
            {(currentUser?.currentRole === UserRole.SuperAdmin ||
              currentUser?.currentRole === UserRole.CollegeAdmin ||
              currentUser?.currentRole === UserRole.DepartmentAdmin ||
              pageBlockData?.displayOrNot) && (
              <div className="d-flex justify-content-end">
                <a data-bs-toggle="modal" data-bs-target="#rateuswrap">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <div className="rate-star">
                      <Rating
                        key={portalRating}
                        initialValue={portalRating}
                        size={30}
                        readonly={true}
                        allowFraction={true}
                        fillColor="#948256"
                        emptyColor="#B0BEC5"
                      />
                    </div>
                    <button
                      className="btn btn-small btn-primary d-flex align-items-center gap-2"
                      onClick={handleOpenModal}
                    >
                      Rate Us
                    </button>
                  </div>
                </a>
              </div>
            )}
          </div>
          {(currentUser?.currentRole === UserRole.SuperAdmin ||
            currentUser?.currentRole === UserRole.CollegeAdmin ||
            currentUser?.currentRole === UserRole.DepartmentAdmin ||
            pageBlockData?.displayOrNot) && (
            <div className="card emailform">
              <div className="label-to mb-3">
                <label htmlFor="">From</label>
                <div className="stude-details">
                  <div className="img">
                    <img
                      src={
                        currentUser?.image ? baseURL + currentUser.image : ""
                      }
                      alt=""
                      onError={(e) =>
                        (e.currentTarget.src =
                          "/assets/images/icon/DefaultImage.jpeg")
                      }
                    />
                  </div>
                  <div className="desc">
                    <h6>{currentUser.displayName}</h6>
                    {currentUser?.currentRole === UserRole.SuperAdmin ? (
                      ""
                    ) : currentUser?.currentRole === UserRole.CollegeAdmin ? (
                      <p>
                        <span>{currentUser?.currentCollege?.name}</span>
                      </p>
                    ) : (
                      <p>
                        {currentUser?.currentDepartment?.name} |{" "}
                        <span>{currentUser?.currentCollege?.name}</span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="formgroup mb-3">
                <label htmlFor="">Subject</label>
                <input
                  type="text"
                  id="subject"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  autoFocus
                />
              </div>
              <div className="formgroup mb-3">
                <label htmlFor="">Message</label>
                <textarea
                  name=""
                  id="message"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                ></textarea>
              </div>
              <div className="btn-flex mb-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSendMail}
                  disabled={isSending}
                >
                  Send
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={onCancel}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <ReactModal
        isOpen={showRating}
        onRequestClose={handleCloseModal}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
      >
        <FeedbackRating setShowRateFeedback={handleCloseModal} />
      </ReactModal>

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={showAlertCancel}
        onCancel={() => {
          setShowAlert(false);
          setShowAlertCancel(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={showAlertCancel ? "Yes" : "Ok"}
      ></SweetAlert>
    </>
  );
};

const mapDispatchToProps = {
  getPortalRating: () => getPortalRating(),
  SendFeedback: (Feedback: ISendMail, callback: Function) =>
    createFeedback(Feedback, callback),
  getToMailId: (emailBlockId: number) => getToMailId(emailBlockId),
  getDescriptionText: (pageBlockId: number) => getDescriptionText(pageBlockId),
  getSnapShot: () => getSnapShots(),
};

function mapStateToProps(state: any) {
  return {
    portalRating: state.common.portalRating?.averageRating,
    toMailId: state.common.toMailId,
    description: state.common.descriptionText,
    currentUser: state.userDetails.userProfileData,
    role: state.userDetails.userProfileData?.currentRole,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);
